import { CarrierFormType } from '~/pages/Settings/Carriers/CarrierForm/CarrierForm';
import { armorAPI } from '~/services/api';
import Carrier from '~/types/Carrier';

export function fetchCarrierFormFields(carrier: Carrier, formType: CarrierFormType) {
  return armorAPI.request({
    url: '/setting/carrier-params',
    method: 'POST',
    data: {
      carrier: carrier.providerToken,
      form_type: formType,
    },
  });
}
